import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'LIVE_INTERVIEW_INVITATION_PAGE_ERROR':
      return action.error;

    case 'LIVE_INTERVIEW_INVITATION_PAGE_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'LIVE_INTERVIEW_INVITATION_PAGE_LOADING':
      return action.loading;

    case 'LIVE_INTERVIEW_INVITATION_PAGE_RESET':
      return false;

    default:
      return state;
  }
}

export function received(state = null, action) {
  switch (action.type) {
    case 'LIVE_INTERVIEW_INVITATION_PAGE_RECEIVED':
      return action.invitation;

    case 'LIVE_INTERVIEW_INVITATION_PAGE_RESET':
      return null;

    default:
      return state;
  }
}

export function newTimeRequested(state = null, action) {
  switch (action.type) {
    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_PAGE_NEW_TIME_REQUESTED':
      return action.requested;

    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_PAGE_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, received, newTimeRequested});
